@if (!addUserExpanded && canEditGroups) {
  <div class="addUsersContainer">
    <button
      class="plusButton plusButton_dark split"
      [ngClass]="{addMember: true, opened: addExpanded, addTeamMemberBtn: true}"
      (click)="addExpanded = !addExpanded"
      [disabled]="projectLocked"
    >Add Team Member</button>
    @if (addExpanded && !projectLocked) {
      <div class="addMembersPane">
        <button class="mat-menu-item addItem" (click)="openAddUser()">Add Individual User</button>
        <button class="mat-menu-item addItem" (click)="openAddGroup()">Add User Group</button>
      </div>
    }
  </div>
}
@if (!canEditGroups) {
  <div>
    <button [disabled]="projectLocked" class="mat-menu-item addItem" (click)="openAddUser()">Add Individual User</button>
  </div>
}
@if (addUserExpanded) {
  <div class="addIndividualContainer">
    <h4
      class="pageHeader addMemberTitle"
      >Add Individual User
      <button class="rightIcon" (click)="closeAddUser()">
        <i class="material-icons">close</i>
      </button>
    </h4>
    <hr>
      @if (allUsers) {
        <app-member-search
          [autofocus]="true"
          [allUsers]="allUsers"
          [allTeamUsers]="allTeamUsers"
          [editMembers]="editMembers"
          [commentMembers]="commentMembers"
          [readMembers]="readMembers"
          [adminMembers]="adminMembers"
          [evalMembers]="evalMembers"
          [editGroups]="editGroups"
          [commentGroups]="commentGroups"
          [readGroups]="readGroups"
          [isUserSearch]="true"
          [isAdding]="true"
          [canEditGroups]="canEditGroups"
          [applicationType]="applicationType"
          (addSignal)="addIndividual($event)"
        ></app-member-search>
      }
    </div>
  }
  @if (addGroupExpanded && canEditGroups) {
    <div class="addGroupContainer">
      <h4
        class="pageHeader addMemberTitle"
        >Add User Group
        <button class="rightIcon" (click)="closeAddGroup()">
          <i class="material-icons">close</i>
        </button>
      </h4>
      <hr>
        @if (allUsers) {
          <app-member-search
            [autofocus]="true"
            [allUsers]="allUsers"
            [allTeamUsers]="allTeamUsers"
            [editMembers]="editMembers"
            [commentMembers]="commentMembers"
            [readMembers]="readMembers"
            [adminMembers]="adminMembers"
            [editGroups]="editGroups"
            [commentGroups]="commentGroups"
            [readGroups]="readGroups"
            [canEditGroups]="canEditGroups"
            [allAvailableGroups]="allAvailableGroups"
            [isGroupSearch]="true"
            [isAdding]="true"
            [applicationType]="applicationType"
            (addGroupSignal)="addGroup($event)"
          ></app-member-search>
        }
      </div>
    }
